const JavascriptDataType = Object.freeze({    
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    UNDEFINED: 'undefined',
    SYMBOL: 'symbol',
    BIGINT: 'bigint',
    NULL: 'null',
    OBJECT: 'object',
    DATE: 'date',
    ARRAY: 'array',
    FUNCTION: 'function'
});
export default JavascriptDataType;